import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

import { CLICKABLE_LABEL_CLASS } from "../ModelCard/constants";

const LabelChip = styled(Chip, {
  shouldForwardProp: (prop: string) => prop !== "isClickable",
})<{ isClickable?: boolean }>(({ theme, isClickable }) => ({
  backgroundColor: theme.palette.secondary["2/25"],
  borderRadius: 9999,
  boxShadow: "0px 16px 70px rgba(0, 0, 0, 0.50)",
  color: theme.palette.secondary[2],
  cursor: isClickable ? "pointer" : "default",
  transition: "background-color 0.15s ease-in-out",
  "&:hover": isClickable
    ? {
        backgroundColor: theme.palette.secondary["2/50"],
      }
    : undefined,
}));

interface LabelProps {
  id?: string;
  label: string;
  onClick?: (event: React.MouseEvent, labelId: string) => void;
}

export const Label = (props: LabelProps) => {
  const { id, label, onClick } = props;

  const isClickable = Boolean(onClick && id);

  const handleClick = (event: React.MouseEvent) => {
    if (onClick && id) {
      event.stopPropagation();
      onClick(event, id);
    }
  };

  return (
    <LabelChip
      key={label}
      className={isClickable ? CLICKABLE_LABEL_CLASS : undefined}
      isClickable={isClickable}
      label={label}
      size="small"
      onClick={isClickable ? handleClick : undefined}
      variant="filled"
    />
  );
};
